import { useMemo } from 'react';
import { UserModel } from '../../app/modules/auth/models/UserModel';
import { ITemplateAnalytic } from '../../interfaces/Analytics/Analytics';

const useAnalyticGuard = (user:UserModel) => {
  return useMemo(() => {
    const featureAccess =   (user.data.settings as unknown as any)['feature_analytic']
    const isSuperAdmin = user?.data?.is_superadmin;
    const anlyticOn = user.data.is_allowed_set_analytic

    const hasAccess = featureAccess !== undefined && featureAccess !== 'false' && (isSuperAdmin || user.data.access_analytic?.length > 0 || user.data.is_allowed_set_analytic );
    const isEditor = anlyticOn
    
    const isOwnerTemplate = (template : ITemplateAnalytic)=>{
      if (isSuperAdmin) return true
      if(template.userCreator === user.data.id && anlyticOn){
        return true
      }
      return false

    }

    const isCanEditTemplate = (templateId: string) => {
        if (isSuperAdmin) return true; 
        return user.data.access_analytic?.some(
          (access) => access.templateId === templateId && access.access === 'EDITOR'
        );
      };

      const isCanViewTemplate = (templateId: string) => {
        if (isSuperAdmin||isEditor) return true; 
        return user.data.access_analytic?.some(
          (access) => access.templateId === templateId && access.access === 'VIEWER'
        );
      };
    
    return { hasAccess, isEditor, isCanEditTemplate, isCanViewTemplate , isOwnerTemplate};
  }, [user]);
};

export default useAnalyticGuard;
